import { render, staticRenderFns } from "./list-claim-form.vue?vue&type=template&id=2fd22f68&"
import script from "./list-claim-form.vue?vue&type=script&lang=js&"
export * from "./list-claim-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports